/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import CRM from '../BaseComponent/CRM'

class AddSubject extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: '',
      categoryList: []
    }
  }
  componentDidMount() {
    http.get(`${CRM.CRM_CONTACT_CATEGORY_LIST}`, {}).then((response) => {
      // alert(JSON.stringify(response.data))
      if (response.data.error == null) {
        this.setState({
          categoryList: response.data.object
        })
      } else {
        this.setState({
          categoryList: []
        })
      }
    })
  }

  addSubject() {
    var name = document.getElementById('name').value
    var contactCategoryId = document.getElementById('contactCategoryId').value
    var enabled = document.getElementById('enabled').value
    var nameError = false
    var enableError = false
    var formError = false
    var catError = false

    if (contactCategoryId == '') {
      formError = true
      catError = true
      message.error('خانواده تماس وارد شود')
    } else {
      if (!catError) {
        this.setState({
          error: ''
        })
      }
    }

    if (name == '') {
      formError = true
      nameError = true
      message.error('عنوان موضوع تماس وارد شود')
    } else {
      if (!nameError) {
        this.setState({
          error: ''
        })
      }
    }

    if (enabled == '') {
      formError = true
      enableError = true
      message.error('وضعیت را مشخص کنید')
    } else {
      if (!enableError) {
        this.setState({
          error: ''
        })
      }
    }
    if (!formError) {
      let data = {
        name,
        enabled,
        contactCategoryId
      }

      http
        .post(`${CRM.CRM_CONTACT_SUBJECT_ADD}`, data)
        .then((response) => {
          if (response.data.error == null) {
            message.success('موضوع تماس جدید اضافه شد')
            setInterval(() => {
              window.location.assign('/reportSubject')
            }, 2000)
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          alert(JSON.stringify(error))
        })
    }
  }

  submit(e) {
    e.preventDefault()
  }
  render() {
    return (
      <div className={'rtl'}>
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>ارتباط با مشتری</li>
            <li>
              <Link to={'/reportSubject'}>موضوع های تماس</Link>
            </li>
            <li>افزودن موضوع تماس</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>ثبت موضوع تماس</p>
            </div>
            <div className="formComponent">
              <label>
                خانواده تماس <span className="requireFiled">*</span>
              </label>
              <select className="form-control" id="contactCategoryId">
                <option value="">------</option>
                {this.state.categoryList.map((category, index) => (
                  <option value={category.contactCategoryId}>{category.contactCategoryName}</option>
                ))}
              </select>

              <label>
                عنوان <span className="requireFiled">*</span>
              </label>
              <input type="text" id="name" className="form-control" />

              <label>
                وضعیت <span className="requireFiled">*</span>
              </label>
              <select className="form-control" name="enabled" id="enabled">
                <option value="">------</option>
                <option value={1}>فعال</option>
                <option value={0}>غیر فعال</option>
              </select>

              <button className="btn btn-info btn-block" onClick={this.addSubject.bind(this)}>
                ثبت موضوع تماس جدید
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default AddSubject
